import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { mapActions, viewActions } from '../state/actions';
import { LAYERS } from 'shared/src/constants/layers';
import { VIEWS } from 'shared/src/constants/views';
import { layerService } from '../services';

class DamageChronologyController extends React.Component {
    componentDidMount() {
        return this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.match.params.id !== prevProps.match.params.id ||
            this.props.location.search !== prevProps.location.search
        ) {
            return this.getData();
        }
    }

    async getData() {
        const { location } = this.props;

        this.props.dispatch(viewActions.setInfoPanelState({ open: true }));
        this.props.dispatch(viewActions.setViewState({ view: VIEWS.PROGRESS }));

        this.props.dispatch(mapActions.resetLayers());

        const damageChronology = await layerService.getDamageChronology();

        this.props.dispatch(
            mapActions.updateLayer({
                type: LAYERS.TYPES.DAMAGE_CHRONOLOGY,
                visible: true,
                damageChronology,
                fittingLayer: false,
            })
        );

        this.props.dispatch(viewActions.setViewState({ view: VIEWS.DAMAGE_CHRONOLOGY }));
    }

    render() {
        return null;
    }
}

export default connect()(withRouter(DamageChronologyController));
